module.exports = __webpack_public_path__ + "media/images/avatar-big-d23f9eae9b17c5525ab2e2a3d4f0a7a3.svg";